import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTransportforlondonComponent } from './simple-icons-transportforlondon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTransportforlondonComponent ],
    exports:      [ SimpleIconsTransportforlondonComponent ],
    bootstrap:    []
})
export class SimpleIconsTransportforlondonModule {}
